import { queryOptions } from '@tanstack/react-query';

import type { DamageGroup, DamageTypeOption, DomainValue, MaterialType } from '@/common/dropdowns';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type DropdownResponseType = {
	domainValues: DomainValue[];
	materialOptions: MaterialType[];
	damageGroups: DamageGroup[];
	damageOptions: DamageTypeOption[];
};

async function getDropdowns(): Promise<DropdownResponseType | null> {
	const response = await axios.get(`${API_URLS.APP_CONFIG.DROPDOWNS}`);
	return getResponse<DropdownResponseType>(response.data);
}

export function getDropdownsOptions() {
	return queryOptions({
		queryKey: ['appconfig', 'list', 'dropdowns'],
		queryFn: () => getDropdowns(),

		staleTime: 1000 * 60 * 10, // 10 minutes

		// do not refetch on window focus to avoid unnecessary API calls
		refetchOnWindowFocus: false,
	});
}
